'use strict';

import angular from  "angular";

import "angular-route";
import "angular-sanitize";

import "./login";
import "../../common/utils";

import "../../lib/angular-foundation.min";


export default angular.module('fastx.auth', [
	'ngRoute',
	'mm.foundation',
	'fastx.utils',
	'Login',
	'ngSanitize'
])
.run(['$rootScope','Token','$location',function($rootScope,Token,$location){
	$rootScope.pageTitle = 'Login';
}])
.factory('LoginSuccess',['$window','$location','Token','Version',function($window,$location,Token,Version){
	return function (data){
		$window.localStorage['host'] = data.host;
		$window.location.reload();
	}
}])
.factory('LoginStage',['$rootScope','LoginSuccess','Login','PrivKey',function($rootScope,LoginSuccess,Login,PrivKey){
	var stage = {};
	PrivKey.loadKeys();
	var k;
	function error(e){
		$rootScope.error = e.error || e;
		nextStage({stage:'init'});
	}
	function nextStage(data,passphrase){
		if(data){
			stage = data;
			$rootScope.stage = data.stage;
			switch(data.stage){
				case 'error':
					error(data.error);
					break;
				case 'success':
					LoginSuccess(data);
					break;
				case 'keyboard-interactive':

					break;
				case 'public-key':
					k = PrivKey.loadNextKey();
					if(k){
						stage.privateKey = k;
						if(!k.encrypted){
							Login.publicKey(PrivKey.getPublicKeyBlob(k),data.token,nextStage,error);
						}
					}else{
						Login.publicKey(null,data.token,nextStage,error);
					}
					break;
				case 'sign':
					Login.publicKeySigned(PrivKey.sign(k,data.signData,passphrase),data.token,nextStage,error);
					break;
				default:
					break;
			}
		}
		return stage;
	}
	return nextStage;
}])
.controller('AuthCtrl', ['$scope','LoginStage','Token','$location','$window',
			function ($scope,LoginStage,Token,$location,$window) {
	$scope.o ={};
	LoginStage({stage:'init'});
}])
.controller('AdminAuthCtrl', ['$scope','LoginStage','Token','$location',function ($scope,LoginStage,Token,$location) {
	$scope.o = {
		admin:true
	};
	LoginStage({stage:'init'});
}])
.controller('InitCtrl',['$scope','Login','Servers','LoginError','LoginStage','$window','PrivKey','$modal',
			function($scope,Login,Servers,error,LoginStage,$window,PrivKey,$modal){
	Servers(function(data){
		$scope.o.serverId = Object.keys(data)[0];
		$scope.servers = data;
		$scope.showServers = Object.keys(data).length > 1 ;
	});

	function myError(e){
		$scope.o.username ='';
		$scope.o.password ='';
		$scope.disabled = false;
		error(e);
	}
	$scope.d = {};
	Login.getEnv(function(d){
		$scope.d= d;
		angular.extend($scope.o,{
			usePK:d.publicKey && (PrivKey.loadKeys().length > 0),
			basic:d.basic
		});
	});

	$scope.disabled = false;

	$scope.login = function(o){
		$scope.disabled = true;
		Login.login(o,function(data){
			$window.localStorage['username'] = o.username;
			if(data.stage === 'keyboard-interactive' && o.password && data.prompt && (data.prompt.search(/password/i)>=0) ){
				Login.keyboardInteractive(o.password,data.token,function(data){
					$scope.disabled = false;
					LoginStage(data);
				},myError);
			}else{
				$scope.disabled = false;
				LoginStage(data);
			}
		},myError);
	}

	$scope.loadKeys = function(pk){
		if(pk){
			$scope.privateKeys();
		}
	}
	$scope.privateKeys = function(checked){
		var mi = $modal.open({
				controller:'ManagePrivKeyDlgCtrl',
			    templateUrl:'js/ssh/auth/manage-private-key-dialog.html'
			});
	}
}])
.controller('PasswordCtrl',['$scope','Login','LoginSuccess','LoginError','LoginStage',function($scope,Login,success,error,LoginStage){
	$scope.disabled = false;
	$scope.password = function(answer){
		$scope.disabled = true;
		Login.password(answer,LoginStage().token,LoginStage,error);
	}
	$scope.cancelLogin = function(){
		$window.location.reload();
	}
}])
.controller('KeyboardInteractiveCtrl',['$scope','$window','Login','LoginError','LoginStage',function($scope,$window,Login,error,LoginStage){
	$scope.disabled = false;
	$scope.prompt = LoginStage().prompt;
	$scope.answer = '';
	$scope.keyboardInteractive = function(answer){
		Login.keyboardInteractive(answer,LoginStage().token,function(data){
			$scope.prompt = LoginStage(data).prompt;
			$scope.answer = '';
		},error);
	}
}])
.controller('PublicKeyCtrl',['$scope','Login','LoginError','LoginStage','PrivKey','$window',function($scope,Login,LoginError,LoginStage,PrivKey,$window){
	$scope.disabled = false;
	$scope.key = LoginStage().privateKey;
	$scope.decryptKey = function(key,passphrase){
		var blob = PrivKey.getPublicKeyBlob(key,passphrase);
		if(blob){
			Login.publicKey(blob, LoginStage().token,function(data){$scope.disabled = true; LoginStage(data,passphrase)},LoginError);
		}else{
			$scope.disabled = false;
			$scope.passphrase = '';
			$scope.error = {message:'Failed to decrypt key'}
		}
	}
	$scope.cancel = function(){
		$window.location.reload();
	}
	$scope.tryNextAuth = function(){
		delete $scope.error;
		$scope.passphrase ='';
		LoginStage(LoginStage());
	}
}])
.controller('CancelLoginCtrl',['$scope','$window',function($scope,$window){
	$scope.cancelLogin = function(){
		$window.location.reload();
	}
}])
.controller('UsePKCtrl',['$scope','PrivKey',function($scope,PrivKey){

}])
.controller('ManagePrivKeyDlgCtrl',['$scope','PrivKey','$modalInstance',function($scope,PrivKey,mi){
	var refresh = function(){
		$scope.error = null;
		$scope.keys = PrivKey.loadKeys();
	};
	$scope.deleteKey = function(key){
		PrivKey.deleteKey(key);
		refresh();
	}
	$scope.close = function(){
		mi.close();
	}
	$scope.file_changed = function(element) {
		$scope.$apply(function(scope) {
			var file = element.files[0];
			var reader = new FileReader();
			reader.onload = function() {
				if(PrivKey.storeKey(reader.result,file.name)){
					$scope.$apply(function(){
						refresh();
					});
				}else{
					$scope.$apply(function(){
						$scope.error = {message:'Invalid Private Key Format'};
					});
				}
			};
			if(file){
				reader.readAsText(file);
			}
		});
	};
	refresh();
}])
.factory('LoginError',['$location','$rootScope','LoginStage',function($location,$rootScope,LoginStage){
	return function loginError(e){
		if(e.code === -32015){//fastx installation error
			$location.path('error');
			return;
		}
		LoginStage({stage:'error',error:e.error});
	}
}])


.factory('Servers',['Api',function(Api){
	return function(success,error){
		Api.get('api/server',{},success,error);
	}
}])
.directive('autofocus', ['$timeout', function($timeout) {
  return {
    restrict: 'A',
    link : function($scope, $element) {
      $timeout(function() {
        $element[0].focus();
      });
    }
  }
}]);



//////////////////
// WEBPACK FOOTER
// ./auth/auth.js
// module id = 9
// module chunks = 0